module.exports = __webpack_public_path__ + "static/feature-phone-3-cb3fa5d8cc80bf62e73d1b0f1e659858.png";